module.exports = __webpack_public_path__ + "static/img/21.4926cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/21.png
// module id = V7oc
// module chunks = 0